module.exports = __webpack_public_path__ + "media/src/ui/images/tmDevicePhone-3ff96a879fc02b49ea7b76bf171e5be3.svg";